import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../ContentWrapper/Sidebar/Siderbar';
import { HEALTH_MONITOR_DETAILS_URL, HEALTH_MONITOR_URL } from '../../util/url';

const ContentPage: React.FC = () => {
  const location = useLocation();
  const path = location.pathname;

  const getContentWrapperClasses = () => {
    let classes = 'content_wrapper';
    if (path.includes(HEALTH_MONITOR_URL)) {
      classes += ' content_wrapper_health_monitor';
    }
    if (path.includes(HEALTH_MONITOR_DETAILS_URL)) {
      classes += ' content_wrapper_health_monitor_details';
    }
    return classes;
  };

  return (
    <>
      <div className={getContentWrapperClasses()}>
        <Sidebar></Sidebar>
        <Outlet></Outlet>
      </div>
    </>
  );
};

export default ContentPage;
